// extracted by mini-css-extract-plugin
module.exports = {"IAndCLifecycleServices":"IAndCLifecycleServices_IAndCLifecycleServices__2K6Vy"};